// Auto-generated wardrobe assets - DO NOT EDIT
// Generated: 2026-02-01T15:23:48.512Z
// Run: node scripts/generate-assets.js to regenerate

import { IconJacket, IconRainBoots, IconStrawHat, IconSuit, IconSunglasses, IconTShirt, IconToteBag, IconTrousers } from '@/components/ui/icons';
import type { WardrobeCategoryData } from '@/types';
import type { Gender } from '@/types/character';

// Female wardrobe categories
export const FEMALE_WARDROBE_CATEGORIES: WardrobeCategoryData[] = [
  {
    id: 'complete-outfits',
    label: 'Outfits',
    icon: IconSuit,
    items: [
      {
        id: 'outfit-1',
        name: 'Casual Chic',
        category: 'complete-outfits',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/b18896fd-8d35-4ebf-8a2a-15fd8def5a59.png',
        prompt: `Flat lay product photo of women's casual outfit on solid pure white background (#FFFFFF):
          Soft pink blouse, high-waisted light blue jeans, nude ballet flats, gold bracelet.
          Clean overhead view, items neatly arranged in outfit shape.
          Soft even lighting, no shadows, feminine e-commerce product style.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/b18896fd-8d35-4ebf-8a2a-15fd8def5a59.png',
      },
      {
        id: 'outfit-2',
        name: 'Office Ready',
        category: 'complete-outfits',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/bc21bfd2-32f1-4e08-9b00-5dea2f066893.png',
        prompt: `Flat lay product photo of women's business casual outfit on solid pure white background (#FFFFFF):
          White silk blouse, navy pencil skirt, nude heels, pearl earrings.
          Clean overhead view, items neatly arranged in outfit shape.
          Soft even lighting, no shadows, professional women's catalog style.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/bc21bfd2-32f1-4e08-9b00-5dea2f066893.png',
      },
      {
        id: 'outfit-3',
        name: 'Weekend Brunch',
        category: 'complete-outfits',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/27ee3f85-c07a-471f-92ef-c4974c6138cb.png',
        prompt: `Flat lay product photo of women's weekend outfit on solid pure white background (#FFFFFF):
          Cream oversized knit sweater, black leggings, white sneakers, crossbody bag.
          Clean overhead view, items neatly arranged in outfit shape.
          Soft even lighting, no shadows, lifestyle catalog style.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/27ee3f85-c07a-471f-92ef-c4974c6138cb.png',
      },
      {
        id: 'outfit-4',
        name: 'Date Night',
        category: 'complete-outfits',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/e55be3a7-7f2c-473a-b1f6-68e6c4a7d438.png',
        prompt: `Flat lay product photo of women's date night outfit on solid pure white background (#FFFFFF):
          Little black dress, red heels, gold clutch, statement earrings.
          Clean overhead view, items neatly arranged in outfit shape.
          Soft even lighting, no shadows, elegant evening style.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/e55be3a7-7f2c-473a-b1f6-68e6c4a7d438.png',
      },
      {
        id: 'outfit-5',
        name: 'Boho Vibes',
        category: 'complete-outfits',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/8d852e4f-2941-4b61-9c2e-f238bd852c95.png',
        prompt: `Flat lay product photo of women's bohemian outfit on solid pure white background (#FFFFFF):
          Flowy floral maxi skirt, white peasant blouse, brown leather sandals, layered necklaces.
          Clean overhead view, items neatly arranged in outfit shape.
          Soft even lighting, no shadows, relaxed boho style.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/8d852e4f-2941-4b61-9c2e-f238bd852c95.png',
      },
      {
        id: 'outfit-6',
        name: 'Athleisure',
        category: 'complete-outfits',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/78dfba26-25db-45dc-b98e-9b70253794c3.png',
        prompt: `Flat lay product photo of women's athleisure outfit on solid pure white background (#FFFFFF):
          Coral sports bra, matching high-waisted leggings, white sneakers, gym bag.
          Clean overhead view, items neatly arranged in outfit shape.
          Soft even lighting, no shadows, active lifestyle style.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/78dfba26-25db-45dc-b98e-9b70253794c3.png',
      },
      {
        id: 'outfit-7',
        name: 'Summer Vibes',
        category: 'complete-outfits',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/a9e1f781-c0f2-4aa5-b313-c8d94dc4e42b.png',
        prompt: `Flat lay product photo of women's summer outfit on solid pure white background (#FFFFFF):
          Yellow sundress, straw hat, white sandals, woven tote bag.
          Clean overhead view, items neatly arranged in outfit shape.
          Soft even lighting, no shadows, vacation ready style.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/a9e1f781-c0f2-4aa5-b313-c8d94dc4e42b.png',
      },
      {
        id: 'outfit-8',
        name: 'Cozy Fall',
        category: 'complete-outfits',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/a05b4644-c06c-4cf6-8aad-a7af4fd757a3.png',
        prompt: `Flat lay product photo of women's fall outfit on solid pure white background (#FFFFFF):
          Burgundy turtleneck, camel coat, dark jeans, brown ankle boots.
          Clean overhead view, items neatly arranged in outfit shape.
          Soft even lighting, no shadows, autumn aesthetic style.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/a05b4644-c06c-4cf6-8aad-a7af4fd757a3.png',
      },
      {
        id: 'outfit-9',
        name: 'Street Style',
        category: 'complete-outfits',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/12783c23-6208-4e90-b133-82b4cc1fbfab.png',
        prompt: `Flat lay product photo of women's street style outfit on solid pure white background (#FFFFFF):
          Graphic tee, leather jacket, ripped jeans, chunky sneakers.
          Clean overhead view, items neatly arranged in outfit shape.
          Soft even lighting, no shadows, urban cool style.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/12783c23-6208-4e90-b133-82b4cc1fbfab.png',
      },
    ],
  },
  {
    id: 'outerwear',
    label: 'Outerwear',
    icon: IconJacket,
    items: [
      {
        id: 'outerwear-1',
        name: 'Black Leather Jacket',
        category: 'outerwear',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/ecd064f2-7aa7-4e24-8529-cba1533c7f45.png',
        prompt: `Product photo of women's black leather moto jacket on solid white background (#FFFFFF).
          Fitted silhouette with silver hardware and asymmetric zip.
          Front view, ghost mannequin style, floating garment.
          Clean studio lighting, no shadows, sharp details.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/ecd064f2-7aa7-4e24-8529-cba1533c7f45.png',
      },
      {
        id: 'outerwear-2',
        name: 'Blue Denim Jacket',
        category: 'outerwear',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/1853e6d8-f046-4fce-bf19-6b8f7203b307.png',
        prompt: `Product photo of women's cropped blue denim jacket on solid white background (#FFFFFF).
          Classic wash with silver buttons, fitted feminine cut.
          Front view, ghost mannequin style, floating garment.
          Clean studio lighting, no shadows, visible texture.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/1853e6d8-f046-4fce-bf19-6b8f7203b307.png',
      },
      {
        id: 'outerwear-3',
        name: 'Pink Blazer',
        category: 'outerwear',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/336f857b-c740-4434-90bf-bd467fc1d949.png',
        prompt: `Product photo of women's fitted blush pink blazer on solid white background (#FFFFFF).
          Single-breasted with gold buttons, tailored waist.
          Front view, ghost mannequin style, floating garment.
          Clean studio lighting, no shadows, elegant details visible.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/336f857b-c740-4434-90bf-bd467fc1d949.png',
      },
      {
        id: 'outerwear-4',
        name: 'White Puffer',
        category: 'outerwear',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/0c5b5c92-c08c-439b-92b8-b9785cea2258.png',
        prompt: `Product photo of women's cropped white puffer jacket on solid white background (#FFFFFF).
          Modern design with horizontal baffles, stand collar.
          Front view, ghost mannequin style, floating garment.
          Clean studio lighting, no shadows, quilting pattern visible.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/0c5b5c92-c08c-439b-92b8-b9785cea2258.png',
      },
      {
        id: 'outerwear-5',
        name: 'Camel Coat',
        category: 'outerwear',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/e8c3dc66-1d59-45fe-8e6c-b2110218c84c.png',
        prompt: `Product photo of women's long camel wool coat on solid white background (#FFFFFF).
          Classic double-breasted design, belt tie waist.
          Front view, ghost mannequin style, floating garment.
          Clean studio lighting, no shadows, luxurious fabric visible.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/e8c3dc66-1d59-45fe-8e6c-b2110218c84c.png',
      },
      {
        id: 'outerwear-6',
        name: 'Red Trench',
        category: 'outerwear',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/480d037e-9dfe-48c9-a798-e2f9c83f2e6b.png',
        prompt: `Product photo of women's red trench coat on solid white background (#FFFFFF).
          Classic trench design with belt and buttons.
          Front view, ghost mannequin style, floating garment.
          Clean studio lighting, no shadows, bold color pop.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/480d037e-9dfe-48c9-a798-e2f9c83f2e6b.png',
      },
      {
        id: 'outerwear-7',
        name: 'Navy Blazer',
        category: 'outerwear',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/64be47da-80d6-489c-b80c-7a538f506cce.png',
        prompt: `Product photo of women's fitted navy blue blazer on solid white background (#FFFFFF).
          Single-breasted with gold buttons, structured shoulders.
          Front view, ghost mannequin style, floating garment.
          Clean studio lighting, no shadows, professional look.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/64be47da-80d6-489c-b80c-7a538f506cce.png',
      },
      {
        id: 'outerwear-8',
        name: 'Olive Bomber',
        category: 'outerwear',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/4e4aa090-530c-4d8a-8014-4acaf620e341.png',
        prompt: `Product photo of women's olive green bomber jacket on solid white background (#FFFFFF).
          Classic bomber style with ribbed cuffs, zip front.
          Front view, ghost mannequin style, floating garment.
          Clean studio lighting, no shadows, military inspired.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/4e4aa090-530c-4d8a-8014-4acaf620e341.png',
      },
      {
        id: 'outerwear-9',
        name: 'Cream Cardigan',
        category: 'outerwear',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/507c216b-dbc0-4740-8928-9b6d3c23cf0b.png',
        prompt: `Product photo of women's oversized cream chunky knit cardigan on solid white background (#FFFFFF).
          Long length, button front, cozy knit texture.
          Front view, ghost mannequin style, floating garment.
          Clean studio lighting, no shadows, soft texture visible.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/507c216b-dbc0-4740-8928-9b6d3c23cf0b.png',
      },
    ],
  },
  {
    id: 'tops',
    label: 'Tops',
    icon: IconTShirt,
    items: [
      {
        id: 'top-1',
        name: 'White Tee',
        category: 'tops',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/0cc46091-1d72-4ceb-bcfe-5ea1bbee7ba5.png',
        prompt: `Product photo of women's white fitted crew neck t-shirt on solid light gray background (#F0F0F0).
          Slim fit, cap sleeves, slightly scooped neckline.
          Front view, ghost mannequin style, floating garment.
          Soft studio lighting, no harsh shadows.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/0cc46091-1d72-4ceb-bcfe-5ea1bbee7ba5.png',
      },
      {
        id: 'top-2',
        name: 'Black Tee',
        category: 'tops',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/ffd90ff1-fb84-4270-8d41-515999d432f2.png',
        prompt: `Product photo of women's black fitted crew neck t-shirt on solid white background (#FFFFFF).
          Slim fit, cap sleeves, classic neckline.
          Front view, ghost mannequin style, floating garment.
          Clean studio lighting, no shadows.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/ffd90ff1-fb84-4270-8d41-515999d432f2.png',
      },
      {
        id: 'top-3',
        name: 'Ivory Silk Blouse',
        category: 'tops',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/a5d3a864-066e-41a9-92f3-d9479ebbc9b9.png',
        prompt: `Product photo of women's ivory silk blouse on solid white background (#FFFFFF).
          Relaxed fit with V-neck, subtle shine.
          Front view, ghost mannequin style, floating garment.
          Clean studio lighting, no shadows, luxurious fabric.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/a5d3a864-066e-41a9-92f3-d9479ebbc9b9.png',
      },
      {
        id: 'top-4',
        name: 'Navy Silk Blouse',
        category: 'tops',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/96f0f0de-6f2e-44e3-8969-5e720fd26e81.png',
        prompt: `Product photo of women's navy blue silk blouse on solid white background (#FFFFFF).
          Relaxed fit with bow tie neck, elegant drape.
          Front view, ghost mannequin style, floating garment.
          Clean studio lighting, no shadows.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/96f0f0de-6f2e-44e3-8969-5e720fd26e81.png',
      },
      {
        id: 'top-5',
        name: 'Cream Sweater',
        category: 'tops',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/df4c6635-d800-44c9-9838-675c8c794f3b.png',
        prompt: `Product photo of women's soft cream cable-knit sweater on solid white background (#FFFFFF).
          Relaxed fit, crew neck, ribbed cuffs.
          Front view, ghost mannequin style, floating garment.
          Clean studio lighting, cozy texture visible.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/df4c6635-d800-44c9-9838-675c8c794f3b.png',
      },
      {
        id: 'top-6',
        name: 'Lavender Hoodie',
        category: 'tops',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/a60d2f11-3162-4186-aa3d-a255008de1b7.png',
        prompt: `Product photo of women's cropped lavender hoodie on solid white background (#FFFFFF).
          Relaxed crop fit with drawstring hood.
          Front view, ghost mannequin style, floating garment.
          Clean studio lighting, soft fleece texture.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/a60d2f11-3162-4186-aa3d-a255008de1b7.png',
      },
      {
        id: 'top-7',
        name: 'Red Bodysuit',
        category: 'tops',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/6649a732-67f2-46f7-8756-96825aee4a82.png',
        prompt: `Product photo of women's red ribbed bodysuit on solid white background (#FFFFFF).
          Fitted silhouette, scoop neck, sleeveless.
          Front view, ghost mannequin style, floating garment.
          Clean studio lighting, no shadows.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/6649a732-67f2-46f7-8756-96825aee4a82.png',
      },
      {
        id: 'top-8',
        name: 'Striped Top',
        category: 'tops',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/6fbe7f44-ff58-4acc-9ee1-496b7eb76251.png',
        prompt: `Product photo of women's black and white striped long sleeve top on solid white background (#FFFFFF).
          Boat neck, fitted classic Breton stripe.
          Front view, ghost mannequin style, floating garment.
          Clean studio lighting, pattern visible.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/6fbe7f44-ff58-4acc-9ee1-496b7eb76251.png',
      },
      {
        id: 'top-9',
        name: 'Pink Tank',
        category: 'tops',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/e21128d8-893b-427e-bc83-9449236667a9.png',
        prompt: `Product photo of women's soft pink ribbed tank top on solid white background (#FFFFFF).
          Slim fit, scoop neck, thin straps.
          Front view, ghost mannequin style, floating garment.
          Clean studio lighting, subtle rib texture.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/e21128d8-893b-427e-bc83-9449236667a9.png',
      },
    ],
  },
  {
    id: 'bottoms',
    label: 'Bottoms',
    icon: IconTrousers,
    items: [
      {
        id: 'bottom-1',
        name: 'Blue Skinny Jeans',
        category: 'bottoms',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/d4808cb4-4692-474a-a6e3-b29cab0826ac.png',
        prompt: `Product photo of women's high-waisted blue skinny jeans on solid white background (#FFFFFF).
          Stretch denim, five-pocket design, medium wash.
          Front view laid flat, natural drape.
          Clean studio lighting, denim texture visible.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/d4808cb4-4692-474a-a6e3-b29cab0826ac.png',
      },
      {
        id: 'bottom-2',
        name: 'Black Skinny Jeans',
        category: 'bottoms',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/b05172e3-d116-40b0-91e9-148d8af57711.png',
        prompt: `Product photo of women's high-waisted black skinny jeans on solid white background (#FFFFFF).
          Stretch denim, classic five-pocket design.
          Front view laid flat, sleek appearance.
          Clean studio lighting, no shadows.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/b05172e3-d116-40b0-91e9-148d8af57711.png',
      },
      {
        id: 'bottom-3',
        name: 'Cream Wide-Leg',
        category: 'bottoms',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/783ad072-6001-4bf8-a57d-545fd95b8454.png',
        prompt: `Product photo of women's cream wide-leg trousers on solid white background (#FFFFFF).
          High waist, flowing silhouette, clean drape.
          Front view laid flat, elegant appearance.
          Clean studio lighting, fabric quality visible.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/783ad072-6001-4bf8-a57d-545fd95b8454.png',
      },
      {
        id: 'bottom-4',
        name: 'Black Mini Skirt',
        category: 'bottoms',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/26019019-e0fd-4d2e-a036-65561047105d.png',
        prompt: `Product photo of women's black pleated mini skirt on solid white background (#FFFFFF).
          A-line silhouette, high waist, subtle pleats.
          Front view laid flat, clean appearance.
          Clean studio lighting, details clear.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/26019019-e0fd-4d2e-a036-65561047105d.png',
      },
      {
        id: 'bottom-5',
        name: 'Denim Mini Skirt',
        category: 'bottoms',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/0d07d17b-4ed9-45db-b7ba-009ab4d1197c.png',
        prompt: `Product photo of women's light wash denim mini skirt on solid white background (#FFFFFF).
          A-line silhouette, raw hem, button front.
          Front view laid flat, casual style.
          Clean studio lighting, denim texture visible.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/0d07d17b-4ed9-45db-b7ba-009ab4d1197c.png',
      },
      {
        id: 'bottom-6',
        name: 'Floral Midi Dress',
        category: 'bottoms',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/6bcb5459-467d-456d-9c58-62f68ef88f6e.png',
        prompt: `Product photo of women's floral midi dress on solid white background (#FFFFFF).
          Wrap style, delicate floral print on cream background.
          Front view laid flat, feminine silhouette.
          Clean studio lighting, print visible.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/6bcb5459-467d-456d-9c58-62f68ef88f6e.png',
      },
      {
        id: 'bottom-7',
        name: 'Black Leggings',
        category: 'bottoms',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/ee27d066-39f8-4323-81eb-8b1a41d7d945.png',
        prompt: `Product photo of women's black high-waisted leggings on solid white background (#FFFFFF).
          Seamless design, compression fit, ankle length.
          Front view laid flat, sleek appearance.
          Clean studio lighting, no shadows.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/ee27d066-39f8-4323-81eb-8b1a41d7d945.png',
      },
      {
        id: 'bottom-8',
        name: 'Burgundy Midi Skirt',
        category: 'bottoms',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/0cc1c483-3f9c-403e-bbd9-36339ec2b479.png',
        prompt: `Product photo of women's burgundy satin midi skirt on solid white background (#FFFFFF).
          A-line silhouette, subtle sheen, elegant drape.
          Front view laid flat, rich color visible.
          Clean studio lighting, luxurious fabric.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/0cc1c483-3f9c-403e-bbd9-36339ec2b479.png',
      },
      {
        id: 'bottom-9',
        name: 'White Linen Shorts',
        category: 'bottoms',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/e44c4695-ce6b-480e-955b-0f424910c912.png',
        prompt: `Product photo of women's white linen high-waisted shorts on solid white background (#FFFFFF).
          Relaxed fit, paper bag waist with belt.
          Front view laid flat, summer casual style.
          Clean studio lighting, linen texture visible.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/e44c4695-ce6b-480e-955b-0f424910c912.png',
      },
    ],
  },
  {
    id: 'shoes',
    label: 'Shoes',
    icon: IconRainBoots,
    items: [
      {
        id: 'shoe-1',
        name: 'White Sneakers',
        category: 'shoes',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/00e5089c-b280-4755-a803-0be6e7496b49.png',
        prompt: `Product photo of women's clean white leather platform sneakers on solid white background (#FFFFFF).
          Minimalist design, chunky white sole.
          3/4 angle view showing one shoe, slight reflection below.
          Clean studio lighting, crisp details visible.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/00e5089c-b280-4755-a803-0be6e7496b49.png',
      },
      {
        id: 'shoe-2',
        name: 'Nude Ballet Flats',
        category: 'shoes',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/65b5976d-a9e5-4479-895b-1bff1ce7682c.png',
        prompt: `Product photo of women's nude leather ballet flats on solid white background (#FFFFFF).
          Classic design with small bow detail.
          3/4 angle view showing one shoe, slight reflection below.
          Clean studio lighting, leather shine visible.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/65b5976d-a9e5-4479-895b-1bff1ce7682c.png',
      },
      {
        id: 'shoe-3',
        name: 'Black Ankle Boots',
        category: 'shoes',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/7e06fbb5-8acf-40cf-89db-1dfc932f7034.png',
        prompt: `Product photo of women's black suede ankle boots on solid white background (#FFFFFF).
          Block heel, pointed toe, side zip.
          3/4 angle view showing one boot, slight reflection below.
          Clean studio lighting, suede texture visible.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/7e06fbb5-8acf-40cf-89db-1dfc932f7034.png',
      },
      {
        id: 'shoe-4',
        name: 'Gold Heeled Sandals',
        category: 'shoes',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/92681372-b543-4b49-b17c-10c9a3c11ebd.png',
        prompt: `Product photo of women's strappy gold heeled sandals on solid white background (#FFFFFF).
          Delicate straps, block heel, elegant design.
          3/4 angle view showing one shoe, slight reflection below.
          Clean studio lighting, metallic shine visible.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/92681372-b543-4b49-b17c-10c9a3c11ebd.png',
      },
      {
        id: 'shoe-5',
        name: 'Red Heels',
        category: 'shoes',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/b26594ad-bcf2-48c0-b170-f3c36fd012bc.png',
        prompt: `Product photo of women's red patent leather stiletto heels on solid white background (#FFFFFF).
          Classic pointed toe pump, 4-inch heel.
          3/4 angle view showing one shoe, slight reflection below.
          Clean studio lighting, glossy finish visible.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/b26594ad-bcf2-48c0-b170-f3c36fd012bc.png',
      },
      {
        id: 'shoe-6',
        name: 'Black Loafers',
        category: 'shoes',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/d4f8a6a4-28fe-474c-afe2-8c5ba20e47fb.png',
        prompt: `Product photo of women's black leather loafers on solid white background (#FFFFFF).
          Platform sole, chunky design, gold chain detail.
          3/4 angle view showing one shoe, slight reflection below.
          Clean studio lighting, leather quality visible.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/d4f8a6a4-28fe-474c-afe2-8c5ba20e47fb.png',
      },
      {
        id: 'shoe-7',
        name: 'Pink Sneakers',
        category: 'shoes',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/58fb2fe7-22d8-4668-97f0-e3729ea5d21c.png',
        prompt: `Product photo of women's pastel pink running sneakers on solid white background (#FFFFFF).
          Breathable mesh, cushioned sole, sporty design.
          3/4 angle view showing one shoe, slight reflection below.
          Clean studio lighting, athletic style visible.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/58fb2fe7-22d8-4668-97f0-e3729ea5d21c.png',
      },
      {
        id: 'shoe-8',
        name: 'Tan Sandals',
        category: 'shoes',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/8c526bf7-31cd-4bf0-9eab-a6d16060b5df.png',
        prompt: `Product photo of women's tan leather flat sandals on solid white background (#FFFFFF).
          Minimalist strappy design, comfortable flat sole.
          3/4 angle view showing one shoe, slight reflection below.
          Clean studio lighting, leather natural tone.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/8c526bf7-31cd-4bf0-9eab-a6d16060b5df.png',
      },
      {
        id: 'shoe-9',
        name: 'White Boots',
        category: 'shoes',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/ce5611b7-2733-4454-ad72-2cff37eeeee0.png',
        prompt: `Product photo of women's white leather knee-high boots on solid white background (#FFFFFF).
          Block heel, pointed toe, modern design.
          3/4 angle view showing one boot, slight reflection below.
          Clean studio lighting, sleek silhouette visible.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/ce5611b7-2733-4454-ad72-2cff37eeeee0.png',
      },
    ],
  },
  {
    id: 'glasses',
    label: 'Glasses',
    icon: IconSunglasses,
    items: [
      {
        id: 'glasses-1',
        name: 'Black Cat Eye',
        category: 'glasses',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/952b914b-8a26-45ef-9ca5-4ee9ae3e35a0.png',
        prompt: `Product photo of women's black cat eye sunglasses on solid white background (#FFFFFF).
          Classic cat eye shape, black acetate frame, dark lenses.
          Front view, floating centered, slight shadow below.
          Clean studio lighting, glamorous retro style.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/952b914b-8a26-45ef-9ca5-4ee9ae3e35a0.png',
      },
      {
        id: 'glasses-2',
        name: 'Tortoise Shell',
        category: 'glasses',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/620ecfc8-3c94-4ed0-9b01-006b55b9a927.png',
        prompt: `Product photo of women's tortoise shell sunglasses on solid white background (#FFFFFF).
          Oversized round frame, brown tortoise pattern, gradient lenses.
          Front view, floating centered, slight shadow below.
          Clean studio lighting, sophisticated style.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/620ecfc8-3c94-4ed0-9b01-006b55b9a927.png',
      },
      {
        id: 'glasses-3',
        name: 'Gold Aviator',
        category: 'glasses',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/a80bb5da-0cfe-417a-a44c-cd13c0b18183.png',
        prompt: `Product photo of women's gold aviator sunglasses on solid white background (#FFFFFF).
          Classic aviator shape, gold metal frame, brown gradient lenses.
          Front view, floating centered, slight shadow below.
          Clean studio lighting, timeless elegance.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/a80bb5da-0cfe-417a-a44c-cd13c0b18183.png',
      },
      {
        id: 'glasses-4',
        name: 'Pink Oversized',
        category: 'glasses',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/9f306f8a-7e95-402e-87aa-a453f205eaae.png',
        prompt: `Product photo of women's pink oversized square sunglasses on solid white background (#FFFFFF).
          Large square frame, translucent pink acetate, rose tinted lenses.
          Front view, floating centered, slight shadow below.
          Clean studio lighting, trendy feminine style.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/9f306f8a-7e95-402e-87aa-a453f205eaae.png',
      },
      {
        id: 'glasses-5',
        name: 'White Round',
        category: 'glasses',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/5a21b433-df01-4559-b642-080474333b76.png',
        prompt: `Product photo of women's white round sunglasses on solid white background (#FFFFFF).
          Round frame, white acetate, dark lenses.
          Front view, floating centered, slight shadow below.
          Clean studio lighting, retro chic style.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/5a21b433-df01-4559-b642-080474333b76.png',
      },
      {
        id: 'glasses-6',
        name: 'Clear Frame',
        category: 'glasses',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/352dcdb3-51e1-40c9-a7b2-43507274cdf6.png',
        prompt: `Product photo of women's clear frame eyeglasses on solid white background (#FFFFFF).
          Round-square shape, clear transparent acetate frame.
          Front view, floating centered, slight shadow below.
          Clean studio lighting, modern minimalist style.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/352dcdb3-51e1-40c9-a7b2-43507274cdf6.png',
      },
      {
        id: 'glasses-7',
        name: 'Red Cat Eye',
        category: 'glasses',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/5ecbcc32-8950-4705-b6df-951808254cf6.png',
        prompt: `Product photo of women's red cat eye sunglasses on solid white background (#FFFFFF).
          Dramatic cat eye shape, cherry red frame, dark lenses.
          Front view, floating centered, slight shadow below.
          Clean studio lighting, bold statement style.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/5ecbcc32-8950-4705-b6df-951808254cf6.png',
      },
      {
        id: 'glasses-8',
        name: 'Brown Square',
        category: 'glasses',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/ce3762e2-e4ba-4c68-af27-8f74542faedd.png',
        prompt: `Product photo of women's brown square eyeglasses on solid white background (#FFFFFF).
          Modern square shape, warm brown acetate frame.
          Front view, floating centered, slight shadow below.
          Clean studio lighting, sophisticated professional style.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/ce3762e2-e4ba-4c68-af27-8f74542faedd.png',
      },
      {
        id: 'glasses-9',
        name: 'Black Rectangular',
        category: 'glasses',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/4c8ff498-dc4d-47c5-972c-37c7ef154a81.png',
        prompt: `Product photo of women's black rectangular eyeglasses on solid white background (#FFFFFF).
          Slim rectangular frame, black acetate, modern design.
          Front view, floating centered, slight shadow below.
          Clean studio lighting, sleek professional style.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/4c8ff498-dc4d-47c5-972c-37c7ef154a81.png',
      },
    ],
  },
  {
    id: 'bags',
    label: 'Bags',
    icon: IconToteBag,
    items: [
      {
        id: 'bag-1',
        name: 'Black Tote',
        category: 'bags',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/abff40d5-5499-4b73-8734-40ac413c7462.png',
        prompt: `Product photo of women's black leather tote bag on solid white background (#FFFFFF).
          Large structured tote, gold hardware, dual handles.
          3/4 angle view, standing upright.
          Clean studio lighting, luxurious texture visible.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/abff40d5-5499-4b73-8734-40ac413c7462.png',
      },
      {
        id: 'bag-2',
        name: 'Tan Crossbody',
        category: 'bags',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/687569b1-0e75-4f66-a76d-261915a8ab40.png',
        prompt: `Product photo of women's tan leather crossbody bag on solid white background (#FFFFFF).
          Medium saddle bag style, adjustable strap, gold clasp.
          3/4 angle view, strap artfully draped.
          Clean studio lighting, warm leather tone.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/687569b1-0e75-4f66-a76d-261915a8ab40.png',
      },
      {
        id: 'bag-3',
        name: 'Pink Clutch',
        category: 'bags',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/4695ad3e-071a-421b-9705-75461e4ec801.png',
        prompt: `Product photo of women's pink satin clutch bag on solid white background (#FFFFFF).
          Elegant envelope clutch, gold chain strap, soft blush pink.
          Flat lay slightly angled, chain visible.
          Clean studio lighting, evening elegance.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/4695ad3e-071a-421b-9705-75461e4ec801.png',
      },
      {
        id: 'bag-4',
        name: 'White Shoulder Bag',
        category: 'bags',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/16ad443d-cf4b-431d-b145-09452c38feb3.png',
        prompt: `Product photo of women's white quilted shoulder bag on solid white background (#FFFFFF).
          Classic quilted pattern, silver chain strap, flap closure.
          3/4 angle view, standing upright.
          Clean studio lighting, timeless luxury style.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/16ad443d-cf4b-431d-b145-09452c38feb3.png',
      },
      {
        id: 'bag-5',
        name: 'Red Mini Bag',
        category: 'bags',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/05550830-a710-40a1-ae4c-aa42ce2fb332.png',
        prompt: `Product photo of women's red mini handbag on solid white background (#FFFFFF).
          Petite structured bag, top handle, gold hardware.
          3/4 angle view, standing upright.
          Clean studio lighting, bold statement piece.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/05550830-a710-40a1-ae4c-aa42ce2fb332.png',
      },
      {
        id: 'bag-6',
        name: 'Straw Beach Tote',
        category: 'bags',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/163bed23-66f3-4aeb-a9a6-e99a4f821c89.png',
        prompt: `Product photo of women's straw beach tote on solid white background (#FFFFFF).
          Large woven straw bag, leather handles, open top.
          3/4 angle view, casual summer style.
          Clean studio lighting, natural texture visible.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/163bed23-66f3-4aeb-a9a6-e99a4f821c89.png',
      },
      {
        id: 'bag-7',
        name: 'Navy Backpack',
        category: 'bags',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/d22aec0a-4927-453d-bd3b-f4e7f913df1b.png',
        prompt: `Product photo of women's navy leather mini backpack on solid white background (#FFFFFF).
          Compact backpack design, adjustable straps, zip closure.
          3/4 angle view, standing upright.
          Clean studio lighting, practical elegance.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/d22aec0a-4927-453d-bd3b-f4e7f913df1b.png',
      },
      {
        id: 'bag-8',
        name: 'Gold Evening Bag',
        category: 'bags',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/417bedc3-49fa-4dd6-a287-f872c191ab6b.png',
        prompt: `Product photo of women's gold metallic evening bag on solid white background (#FFFFFF).
          Small structured box bag, crystal clasp, chain strap.
          3/4 angle view, glamorous sparkle.
          Clean studio lighting, party ready style.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/417bedc3-49fa-4dd6-a287-f872c191ab6b.png',
      },
      {
        id: 'bag-9',
        name: 'Brown Hobo Bag',
        category: 'bags',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/c5eff700-4409-4241-83de-b306434e56cb.png',
        prompt: `Product photo of women's brown leather hobo bag on solid white background (#FFFFFF).
          Slouchy crescent shape, single shoulder strap, zipper top.
          3/4 angle view, relaxed casual style.
          Clean studio lighting, soft leather visible.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/c5eff700-4409-4241-83de-b306434e56cb.png',
      },
    ],
  },
  {
    id: 'hats',
    label: 'Hats',
    icon: IconStrawHat,
    items: [
      {
        id: 'hat-1',
        name: 'Black Beret',
        category: 'hats',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/d275bc71-9f22-4af6-861f-fc7a4a567499.png',
        prompt: `Product photo of women's black wool beret on solid white background (#FFFFFF).
          Classic French beret shape, soft black wool.
          3/4 angle view, styled as if on invisible head.
          Clean studio lighting, artistic Parisian style.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/d275bc71-9f22-4af6-861f-fc7a4a567499.png',
      },
      {
        id: 'hat-2',
        name: 'Straw Sun Hat',
        category: 'hats',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/188ec45f-3b9d-4dad-bac6-b6f94eaa30f6.png',
        prompt: `Product photo of women's wide brim straw sun hat on solid white background (#FFFFFF).
          Large floppy brim, natural straw, ribbon band.
          3/4 angle view, beach ready elegance.
          Clean studio lighting, summer vacation style.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/188ec45f-3b9d-4dad-bac6-b6f94eaa30f6.png',
      },
      {
        id: 'hat-3',
        name: 'Pink Baseball Cap',
        category: 'hats',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/1121be23-a3bf-4c6f-9466-d948c9e031fd.png',
        prompt: `Product photo of women's pink baseball cap on solid white background (#FFFFFF).
          Classic curved brim, soft pink cotton, adjustable back.
          3/4 angle view, casual sporty style.
          Clean studio lighting, athleisure aesthetic.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/1121be23-a3bf-4c6f-9466-d948c9e031fd.png',
      },
      {
        id: 'hat-4',
        name: 'Camel Fedora',
        category: 'hats',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/138a7f9a-1576-4cb9-b7e9-13a945010626.png',
        prompt: `Product photo of women's camel wool fedora on solid white background (#FFFFFF).
          Classic fedora shape, warm camel color, brown ribbon band.
          3/4 angle view, sophisticated boho style.
          Clean studio lighting, autumn elegance.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/138a7f9a-1576-4cb9-b7e9-13a945010626.png',
      },
      {
        id: 'hat-5',
        name: 'White Bucket Hat',
        category: 'hats',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/71c28ce6-254c-455d-845c-f17902c4b620.png',
        prompt: `Product photo of women's white cotton bucket hat on solid white background (#FFFFFF).
          Soft bucket shape, downward brim, clean white.
          3/4 angle view, trendy street style.
          Clean studio lighting, Y2K revival aesthetic.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/71c28ce6-254c-455d-845c-f17902c4b620.png',
      },
      {
        id: 'hat-6',
        name: 'Black Wide Brim',
        category: 'hats',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/c8f3c6e6-2797-4d76-b92a-987b2bc10143.png',
        prompt: `Product photo of women's black wide brim felt hat on solid white background (#FFFFFF).
          Dramatic wide brim, black wool felt, minimal design.
          3/4 angle view, editorial style.
          Clean studio lighting, chic sophistication.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/c8f3c6e6-2797-4d76-b92a-987b2bc10143.png',
      },
      {
        id: 'hat-7',
        name: 'Cream Beanie',
        category: 'hats',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/04543117-130d-4b68-9a5f-4fa2afad86c0.png',
        prompt: `Product photo of women's cream ribbed beanie on solid white background (#FFFFFF).
          Soft knit beanie, slouchy fit, warm cream color.
          3/4 angle view, cozy winter style.
          Clean studio lighting, casual comfort.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/04543117-130d-4b68-9a5f-4fa2afad86c0.png',
      },
      {
        id: 'hat-8',
        name: 'Leopard Print Beret',
        category: 'hats',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/a58045c0-c58f-455d-92ba-439ebb1e45ff.png',
        prompt: `Product photo of women's leopard print beret on solid white background (#FFFFFF).
          Classic beret shape, leopard animal print pattern.
          3/4 angle view, bold statement piece.
          Clean studio lighting, fashion forward style.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/a58045c0-c58f-455d-92ba-439ebb1e45ff.png',
      },
      {
        id: 'hat-9',
        name: 'Navy Newsboy Cap',
        category: 'hats',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/82a7b760-0a01-4fe2-959f-be930f84a6a8.png',
        prompt: `Product photo of women's navy newsboy cap on solid white background (#FFFFFF).
          Vintage newsboy shape, navy tweed fabric, button top.
          3/4 angle view, classic vintage style.
          Clean studio lighting, retro elegance.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/82a7b760-0a01-4fe2-959f-be930f84a6a8.png',
      },
    ],
  },
];

// Male wardrobe categories
export const MALE_WARDROBE_CATEGORIES: WardrobeCategoryData[] = [
  {
    id: 'complete-outfits',
    label: 'Outfits',
    icon: IconSuit,
    items: [
      {
        id: 'outfit-1',
        name: 'Casual Friday',
        category: 'complete-outfits',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/8fecdde9-c438-48ce-bcc9-dd01207aa727.png',
        prompt: `Flat lay product photo of men's casual outfit on solid pure white background (#FFFFFF):
          Light blue chambray shirt, dark indigo jeans, brown belt, white sneakers.
          Clean overhead view, items neatly arranged in outfit shape.
          Soft even lighting, no shadows, masculine style.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/8fecdde9-c438-48ce-bcc9-dd01207aa727.png',
      },
      {
        id: 'outfit-2',
        name: 'Business Casual',
        category: 'complete-outfits',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/81b81d0c-b730-47d5-a96f-98aa2f6a437c.png',
        prompt: `Flat lay product photo of men's business casual outfit on solid pure white background (#FFFFFF):
          White oxford shirt, navy chinos, cognac leather belt, brown loafers.
          Clean overhead view, items neatly arranged in outfit shape.
          Soft even lighting, no shadows, professional style.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/81b81d0c-b730-47d5-a96f-98aa2f6a437c.png',
      },
      {
        id: 'outfit-3',
        name: 'Weekend Vibes',
        category: 'complete-outfits',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/e5debc3e-7761-4fc1-bac2-db4babb537f4.png',
        prompt: `Flat lay product photo of men's weekend outfit on solid pure white background (#FFFFFF):
          Gray crewneck sweatshirt, black joggers, white running shoes.
          Clean overhead view, items neatly arranged in outfit shape.
          Soft even lighting, no shadows, lifestyle style.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/e5debc3e-7761-4fc1-bac2-db4babb537f4.png',
      },
      {
        id: 'outfit-4',
        name: 'Date Night',
        category: 'complete-outfits',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/213b015b-c4a0-4a9f-a5c2-441af27721bd.png',
        prompt: `Flat lay product photo of men's date night outfit on solid pure white background (#FFFFFF):
          Black dress shirt, dark gray dress pants, black leather shoes, silver watch.
          Clean overhead view, items neatly arranged in outfit shape.
          Soft even lighting, no shadows, elegant evening style.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/213b015b-c4a0-4a9f-a5c2-441af27721bd.png',
      },
      {
        id: 'outfit-5',
        name: 'Summer Cool',
        category: 'complete-outfits',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/3fcc7138-b161-4809-a589-1a8243216505.png',
        prompt: `Flat lay product photo of men's summer outfit on solid pure white background (#FFFFFF):
          White linen shirt, beige shorts, brown leather sandals, sunglasses.
          Clean overhead view, items neatly arranged in outfit shape.
          Soft even lighting, no shadows, vacation ready style.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/3fcc7138-b161-4809-a589-1a8243216505.png',
      },
      {
        id: 'outfit-6',
        name: 'Gym Ready',
        category: 'complete-outfits',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/762ee179-986c-4dba-9895-9fe9130a972b.png',
        prompt: `Flat lay product photo of men's athletic outfit on solid pure white background (#FFFFFF):
          Black tank top, gray athletic shorts, running shoes, gym bag.
          Clean overhead view, items neatly arranged in outfit shape.
          Soft even lighting, no shadows, active lifestyle style.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/762ee179-986c-4dba-9895-9fe9130a972b.png',
      },
      {
        id: 'outfit-7',
        name: 'Smart Casual',
        category: 'complete-outfits',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/f2cc6ae2-f250-4c8a-8c4a-9730c5ea2cf0.png',
        prompt: `Flat lay product photo of men's smart casual outfit on solid pure white background (#FFFFFF):
          Navy blazer, white tee, gray chinos, clean white sneakers.
          Clean overhead view, items neatly arranged in outfit shape.
          Soft even lighting, no shadows, polished casual style.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/f2cc6ae2-f250-4c8a-8c4a-9730c5ea2cf0.png',
      },
      {
        id: 'outfit-8',
        name: 'Fall Layers',
        category: 'complete-outfits',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/542303bd-0b1d-4ca3-8d5a-9681c408aa6b.png',
        prompt: `Flat lay product photo of men's fall outfit on solid pure white background (#FFFFFF):
          Rust sweater, olive jacket, dark jeans, brown boots.
          Clean overhead view, items neatly arranged in outfit shape.
          Soft even lighting, no shadows, autumn aesthetic style.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/542303bd-0b1d-4ca3-8d5a-9681c408aa6b.png',
      },
      {
        id: 'outfit-9',
        name: 'Street Style',
        category: 'complete-outfits',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/1767a32a-c362-47fa-9ace-f609ea595f07.png',
        prompt: `Flat lay product photo of men's street style outfit on solid pure white background (#FFFFFF):
          Graphic hoodie, cargo pants, chunky sneakers, cap.
          Clean overhead view, items neatly arranged in outfit shape.
          Soft even lighting, no shadows, urban cool style.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/1767a32a-c362-47fa-9ace-f609ea595f07.png',
      },
    ],
  },
  {
    id: 'outerwear',
    label: 'Outerwear',
    icon: IconJacket,
    items: [
      {
        id: 'outerwear-1',
        name: 'Black Leather Jacket',
        category: 'outerwear',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/79538a12-24ba-43a1-8831-175b2fb4e2c8.png',
        prompt: `Product photo of men's black leather motorcycle jacket on solid white background (#FFFFFF).
          Classic biker style with silver zippers and hardware.
          Front view, ghost mannequin style, floating garment.
          Clean studio lighting, no shadows, sharp details.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/79538a12-24ba-43a1-8831-175b2fb4e2c8.png',
      },
      {
        id: 'outerwear-2',
        name: 'Blue Denim Jacket',
        category: 'outerwear',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/a60b9ab1-5394-4ee8-b3f1-4b50302182a3.png',
        prompt: `Product photo of men's blue denim trucker jacket on solid white background (#FFFFFF).
          Classic medium-wash indigo with copper buttons.
          Front view, ghost mannequin style, floating garment.
          Clean studio lighting, no shadows, visible texture.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/a60b9ab1-5394-4ee8-b3f1-4b50302182a3.png',
      },
      {
        id: 'outerwear-3',
        name: 'Navy Blazer',
        category: 'outerwear',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/0a8929bd-5f3d-4e92-bd1e-899b12d7eddd.png',
        prompt: `Product photo of men's navy blue wool blazer on solid white background (#FFFFFF).
          Single-breasted with gold buttons, notch lapels.
          Front view, ghost mannequin style, floating garment.
          Clean studio lighting, tailored details visible.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/0a8929bd-5f3d-4e92-bd1e-899b12d7eddd.png',
      },
      {
        id: 'outerwear-4',
        name: 'Black Puffer',
        category: 'outerwear',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/6ccced1e-98a9-4e1d-ae09-656db90eacc5.png',
        prompt: `Product photo of men's black quilted puffer jacket on solid white background (#FFFFFF).
          Modern design with horizontal baffles, high collar.
          Front view, ghost mannequin style, floating garment.
          Clean studio lighting, quilting pattern visible.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/6ccced1e-98a9-4e1d-ae09-656db90eacc5.png',
      },
      {
        id: 'outerwear-5',
        name: 'Camel Overcoat',
        category: 'outerwear',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/a8f21f3e-8f82-4daa-8a7b-13b13c561d43.png',
        prompt: `Product photo of men's camel wool overcoat on solid white background (#FFFFFF).
          Classic single-breasted design, knee length.
          Front view, ghost mannequin style, floating garment.
          Clean studio lighting, luxurious wool texture visible.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/a8f21f3e-8f82-4daa-8a7b-13b13c561d43.png',
      },
      {
        id: 'outerwear-6',
        name: 'Olive Bomber',
        category: 'outerwear',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/f322d3cc-9a6a-4410-ba88-251f689cf183.png',
        prompt: `Product photo of men's olive green bomber jacket on solid white background (#FFFFFF).
          Classic MA-1 style with orange lining, ribbed cuffs.
          Front view, ghost mannequin style, floating garment.
          Clean studio lighting, military inspired details.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/f322d3cc-9a6a-4410-ba88-251f689cf183.png',
      },
      {
        id: 'outerwear-7',
        name: 'Gray Hoodie Jacket',
        category: 'outerwear',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/3d533814-5d64-4671-9de3-552ee88def66.png',
        prompt: `Product photo of men's gray zip-up hoodie jacket on solid white background (#FFFFFF).
          Athletic fit with full zip, drawstring hood.
          Front view, ghost mannequin style, floating garment.
          Clean studio lighting, soft fleece texture.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/3d533814-5d64-4671-9de3-552ee88def66.png',
      },
      {
        id: 'outerwear-8',
        name: 'Burgundy Varsity',
        category: 'outerwear',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/2cde0812-56ae-438d-b2e8-1a16e9c834d3.png',
        prompt: `Product photo of men's burgundy and cream varsity jacket on solid white background (#FFFFFF).
          Classic letterman style with leather sleeves.
          Front view, ghost mannequin style, floating garment.
          Clean studio lighting, two-tone design visible.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/2cde0812-56ae-438d-b2e8-1a16e9c834d3.png',
      },
      {
        id: 'outerwear-9',
        name: 'Khaki Trench',
        category: 'outerwear',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/719212e3-e13b-4470-a392-40a3bc65966c.png',
        prompt: `Product photo of men's khaki trench coat on solid white background (#FFFFFF).
          Double-breasted classic design with belt.
          Front view, ghost mannequin style, floating garment.
          Clean studio lighting, timeless silhouette visible.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/719212e3-e13b-4470-a392-40a3bc65966c.png',
      },
    ],
  },
  {
    id: 'tops',
    label: 'Tops',
    icon: IconTShirt,
    items: [
      {
        id: 'top-1',
        name: 'White T-Shirt',
        category: 'tops',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/4de17550-c7a2-4cd4-8cf3-713060357815.png',
        prompt: `Product photo of men's plain white crew neck t-shirt on solid light gray background (#F0F0F0).
          Classic fit, short sleeves, clean neckline.
          Front view, ghost mannequin style, floating garment.
          Soft studio lighting, visible fabric texture.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/4de17550-c7a2-4cd4-8cf3-713060357815.png',
      },
      {
        id: 'top-2',
        name: 'Black T-Shirt',
        category: 'tops',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/b47fef1c-5a5c-42e8-a3cc-44d10d423d3f.png',
        prompt: `Product photo of men's plain black crew neck t-shirt on solid white background (#FFFFFF).
          Classic fit, short sleeves, clean neckline.
          Front view, ghost mannequin style, floating garment.
          Clean studio lighting, no shadows.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/b47fef1c-5a5c-42e8-a3cc-44d10d423d3f.png',
      },
      {
        id: 'top-3',
        name: 'Black Polo',
        category: 'tops',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/28d53c72-146c-4928-9f31-78c4a8a40840.png',
        prompt: `Product photo of men's black cotton pique polo shirt on solid white background (#FFFFFF).
          Classic fit with collar, two-button placket.
          Front view, ghost mannequin style, floating garment.
          Clean studio lighting, pique texture visible.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/28d53c72-146c-4928-9f31-78c4a8a40840.png',
      },
      {
        id: 'top-4',
        name: 'Blue Oxford',
        category: 'tops',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/bffbf9ab-e818-4edb-804a-dd45b20d01a1.png',
        prompt: `Product photo of men's light blue oxford button-down shirt on solid white background (#FFFFFF).
          Classic fit with button-down collar, chest pocket.
          Front view, ghost mannequin style, floating garment.
          Clean studio lighting, oxford weave visible.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/bffbf9ab-e818-4edb-804a-dd45b20d01a1.png',
      },
      {
        id: 'top-5',
        name: 'White Oxford',
        category: 'tops',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/24234aad-dc20-4dad-a632-5629cd680135.png',
        prompt: `Product photo of men's white oxford button-down shirt on solid white background (#FFFFFF).
          Classic fit with button-down collar, crisp appearance.
          Front view, ghost mannequin style, floating garment.
          Clean studio lighting, professional look.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/24234aad-dc20-4dad-a632-5629cd680135.png',
      },
      {
        id: 'top-6',
        name: 'Gray Hoodie',
        category: 'tops',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/d700de74-a951-483a-915e-ed4c305366a8.png',
        prompt: `Product photo of men's charcoal gray pullover hoodie on solid white background (#FFFFFF).
          Classic fit with drawstring hood, kangaroo pocket.
          Front view, ghost mannequin style, floating garment.
          Clean studio lighting, soft fleece texture.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/d700de74-a951-483a-915e-ed4c305366a8.png',
      },
      {
        id: 'top-7',
        name: 'Navy Polo',
        category: 'tops',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/3defbdb6-5029-422b-a256-a75cec8f10ca.png',
        prompt: `Product photo of men's navy blue cotton polo shirt on solid white background (#FFFFFF).
          Classic fit with collar, contrast trim details.
          Front view, ghost mannequin style, floating garment.
          Clean studio lighting, refined casual look.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/3defbdb6-5029-422b-a256-a75cec8f10ca.png',
      },
      {
        id: 'top-8',
        name: 'Burgundy Sweater',
        category: 'tops',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/4020c775-4460-4ccb-aea6-f86385c2afca.png',
        prompt: `Product photo of men's burgundy crew neck sweater on solid white background (#FFFFFF).
          Classic fit, ribbed cuffs and hem, soft knit.
          Front view, ghost mannequin style, floating garment.
          Clean studio lighting, rich color visible.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/4020c775-4460-4ccb-aea6-f86385c2afca.png',
      },
      {
        id: 'top-9',
        name: 'Striped Tee',
        category: 'tops',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/690a40fa-71d7-4b16-9443-56cba539e7c4.png',
        prompt: `Product photo of men's navy and white striped t-shirt on solid white background (#FFFFFF).
          Classic Breton stripe, crew neck, relaxed fit.
          Front view, ghost mannequin style, floating garment.
          Clean studio lighting, pattern visible.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/690a40fa-71d7-4b16-9443-56cba539e7c4.png',
      },
    ],
  },
  {
    id: 'bottoms',
    label: 'Bottoms',
    icon: IconTrousers,
    items: [
      {
        id: 'bottom-1',
        name: 'Blue Jeans',
        category: 'bottoms',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/1ddb94a5-76d3-4b66-bd89-841e5af5f21a.png',
        prompt: `Product photo of men's classic blue denim jeans on solid white background (#FFFFFF).
          Straight fit, five-pocket design, medium wash.
          Front view laid flat, natural fold at knees.
          Clean studio lighting, denim texture visible.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/1ddb94a5-76d3-4b66-bd89-841e5af5f21a.png',
      },
      {
        id: 'bottom-2',
        name: 'Black Jeans',
        category: 'bottoms',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/4599ac92-1bd5-43c0-a7b4-5ffba1a57916.png',
        prompt: `Product photo of men's black denim jeans on solid white background (#FFFFFF).
          Slim fit, five-pocket design, clean look.
          Front view laid flat, sleek appearance.
          Clean studio lighting, no shadows.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/4599ac92-1bd5-43c0-a7b4-5ffba1a57916.png',
      },
      {
        id: 'bottom-3',
        name: 'Khaki Chinos',
        category: 'bottoms',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/8ee28ecb-b1c6-4b26-9037-437b2911dc7e.png',
        prompt: `Product photo of men's khaki tan chino pants on solid white background (#FFFFFF).
          Slim fit, flat front, belt loops.
          Front view laid flat, clean pressed appearance.
          Clean studio lighting, cotton twill texture.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/8ee28ecb-b1c6-4b26-9037-437b2911dc7e.png',
      },
      {
        id: 'bottom-4',
        name: 'Navy Chinos',
        category: 'bottoms',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/dae809be-c120-4766-ad7d-8ae886ae4957.png',
        prompt: `Product photo of men's navy blue chino pants on solid white background (#FFFFFF).
          Slim fit, flat front, clean tailoring.
          Front view laid flat, professional appearance.
          Clean studio lighting, no shadows.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/dae809be-c120-4766-ad7d-8ae886ae4957.png',
      },
      {
        id: 'bottom-5',
        name: 'Olive Cargo',
        category: 'bottoms',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/7c8e0933-8cbe-4289-a4c8-34244086a53d.png',
        prompt: `Product photo of men's olive green cargo pants on solid white background (#FFFFFF).
          Relaxed fit with side cargo pockets.
          Front view laid flat, pockets visible.
          Clean studio lighting, utility details clear.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/7c8e0933-8cbe-4289-a4c8-34244086a53d.png',
      },
      {
        id: 'bottom-6',
        name: 'Black Joggers',
        category: 'bottoms',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/6f5f662f-0ab4-44a4-8bec-fe424ba8dd79.png',
        prompt: `Product photo of men's black jogger pants on solid white background (#FFFFFF).
          Athletic fit, elastic cuffs, drawstring waist.
          Front view laid flat, comfortable style.
          Clean studio lighting, no shadows.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/6f5f662f-0ab4-44a4-8bec-fe424ba8dd79.png',
      },
      {
        id: 'bottom-7',
        name: 'Navy Shorts',
        category: 'bottoms',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/011a68b2-d537-4246-bf34-a95440653d42.png',
        prompt: `Product photo of men's navy blue chino shorts on solid white background (#FFFFFF).
          Classic fit, flat front, 7-inch inseam.
          Front view laid flat, clean appearance.
          Clean studio lighting, crisp fabric.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/011a68b2-d537-4246-bf34-a95440653d42.png',
      },
      {
        id: 'bottom-8',
        name: 'Khaki Shorts',
        category: 'bottoms',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/deaa0064-a86e-4f7f-95f2-540928dcd1b9.png',
        prompt: `Product photo of men's khaki chino shorts on solid white background (#FFFFFF).
          Classic fit, flat front, casual style.
          Front view laid flat, summer ready.
          Clean studio lighting, no shadows.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/deaa0064-a86e-4f7f-95f2-540928dcd1b9.png',
      },
      {
        id: 'bottom-9',
        name: 'Gray Dress Pants',
        category: 'bottoms',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/abdf7528-9bcd-48b1-bd9e-8bbe3b736537.png',
        prompt: `Product photo of men's charcoal gray dress pants on solid white background (#FFFFFF).
          Slim fit, flat front, professional cut.
          Front view laid flat, tailored appearance.
          Clean studio lighting, fabric quality visible.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/abdf7528-9bcd-48b1-bd9e-8bbe3b736537.png',
      },
    ],
  },
  {
    id: 'shoes',
    label: 'Shoes',
    icon: IconRainBoots,
    items: [
      {
        id: 'shoe-1',
        name: 'White Sneakers',
        category: 'shoes',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/e255624f-a8be-4820-b3f6-d4af60a7f201.png',
        prompt: `Product photo of men's clean white leather low-top sneakers on solid white background (#FFFFFF).
          Minimalist design, white rubber sole.
          3/4 angle view showing one shoe, slight reflection below.
          Clean studio lighting, crisp details visible.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/e255624f-a8be-4820-b3f6-d4af60a7f201.png',
      },
      {
        id: 'shoe-2',
        name: 'Brown Loafers',
        category: 'shoes',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/744df8f2-2f48-450a-b688-6d97c89ea728.png',
        prompt: `Product photo of men's brown leather penny loafers on solid white background (#FFFFFF).
          Classic design with saddle strap.
          3/4 angle view showing one shoe, slight reflection below.
          Clean studio lighting, leather shine visible.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/744df8f2-2f48-450a-b688-6d97c89ea728.png',
      },
      {
        id: 'shoe-3',
        name: 'Tan Chelsea Boots',
        category: 'shoes',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/b8bdf7e6-7c63-4f85-9d58-5ccd8bdf5353.png',
        prompt: `Product photo of men's tan leather Chelsea boots on solid white background (#FFFFFF).
          Sleek design with elastic side panels.
          3/4 angle view showing one boot, slight reflection below.
          Clean studio lighting, leather texture visible.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/b8bdf7e6-7c63-4f85-9d58-5ccd8bdf5353.png',
      },
      {
        id: 'shoe-4',
        name: 'Gray Running Shoes',
        category: 'shoes',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/4e9aca72-7dc7-44a7-b37a-fca94b883ed6.png',
        prompt: `Product photo of men's athletic running shoes on solid white background (#FFFFFF).
          Modern design in gray with green accents, mesh upper.
          3/4 angle view showing one shoe, slight reflection below.
          Clean studio lighting, technical details visible.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/4e9aca72-7dc7-44a7-b37a-fca94b883ed6.png',
      },
      {
        id: 'shoe-5',
        name: 'Black Dress Shoes',
        category: 'shoes',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/9f2a4c94-a794-4737-a9e6-25e4e0308dbb.png',
        prompt: `Product photo of men's black leather oxford dress shoes on solid white background (#FFFFFF).
          Classic cap toe design, polished finish.
          3/4 angle view showing one shoe, slight reflection below.
          Clean studio lighting, elegant shine visible.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/9f2a4c94-a794-4737-a9e6-25e4e0308dbb.png',
      },
      {
        id: 'shoe-6',
        name: 'Navy Sneakers',
        category: 'shoes',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/b3d7090b-2828-49c8-89aa-67cbc77573c3.png',
        prompt: `Product photo of men's navy blue canvas sneakers on solid white background (#FFFFFF).
          Classic low-top design, white rubber sole.
          3/4 angle view showing one shoe, slight reflection below.
          Clean studio lighting, casual style visible.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/b3d7090b-2828-49c8-89aa-67cbc77573c3.png',
      },
      {
        id: 'shoe-7',
        name: 'Black Boots',
        category: 'shoes',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/9333a32a-87fb-4129-82d0-a77b8eff8d39.png',
        prompt: `Product photo of men's black leather lace-up boots on solid white background (#FFFFFF).
          Rugged design, durable sole, classic style.
          3/4 angle view showing one boot, slight reflection below.
          Clean studio lighting, masculine aesthetic.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/9333a32a-87fb-4129-82d0-a77b8eff8d39.png',
      },
      {
        id: 'shoe-8',
        name: 'Brown Boat Shoes',
        category: 'shoes',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/049e9ad0-e1b2-4808-920c-9a914b6be891.png',
        prompt: `Product photo of men's brown leather boat shoes on solid white background (#FFFFFF).
          Classic nautical design, rawhide laces.
          3/4 angle view showing one shoe, slight reflection below.
          Clean studio lighting, preppy style visible.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/049e9ad0-e1b2-4808-920c-9a914b6be891.png',
      },
      {
        id: 'shoe-9',
        name: 'Black Sneakers',
        category: 'shoes',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/4d8b83c4-6e71-4809-a73a-0e87bc8dede2.png',
        prompt: `Product photo of men's black leather sneakers on solid white background (#FFFFFF).
          Minimalist design, black rubber sole.
          3/4 angle view showing one shoe, slight reflection below.
          Clean studio lighting, sleek monochrome look.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/4d8b83c4-6e71-4809-a73a-0e87bc8dede2.png',
      },
    ],
  },
  {
    id: 'glasses',
    label: 'Glasses',
    icon: IconSunglasses,
    items: [
      {
        id: 'glasses-1',
        name: 'Black Wayfarers',
        category: 'glasses',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/42428935-bb28-47a6-b860-4aede3d73a2b.png',
        prompt: `Product photo of men's black wayfarer sunglasses on solid white background (#FFFFFF).
          Classic wayfarer shape, matte black frame, dark lenses.
          Front view, floating centered, slight shadow below.
          Clean studio lighting, timeless cool style.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/42428935-bb28-47a6-b860-4aede3d73a2b.png',
      },
      {
        id: 'glasses-2',
        name: 'Gold Aviators',
        category: 'glasses',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/07646e04-7129-4c6d-b0de-c591e5c1eda8.png',
        prompt: `Product photo of men's gold aviator sunglasses on solid white background (#FFFFFF).
          Classic aviator shape, gold metal frame, green tinted lenses.
          Front view, floating centered, slight shadow below.
          Clean studio lighting, iconic pilot style.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/07646e04-7129-4c6d-b0de-c591e5c1eda8.png',
      },
      {
        id: 'glasses-3',
        name: 'Tortoise Clubmaster',
        category: 'glasses',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/72d0885a-f6bb-4e0b-85e6-333ef6108a17.png',
        prompt: `Product photo of men's tortoise clubmaster sunglasses on solid white background (#FFFFFF).
          Browline clubmaster shape, tortoise top with gold trim.
          Front view, floating centered, slight shadow below.
          Clean studio lighting, intellectual sophistication.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/72d0885a-f6bb-4e0b-85e6-333ef6108a17.png',
      },
      {
        id: 'glasses-4',
        name: 'Black Round',
        category: 'glasses',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/80b62243-d43f-4759-858b-1ad684c0eaf6.png',
        prompt: `Product photo of men's black round eyeglasses on solid white background (#FFFFFF).
          John Lennon style round frame, black metal.
          Front view, floating centered, slight shadow below.
          Clean studio lighting, artistic vintage style.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/80b62243-d43f-4759-858b-1ad684c0eaf6.png',
      },
      {
        id: 'glasses-5',
        name: 'Gunmetal Rectangular',
        category: 'glasses',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/9b4b8d54-18ce-46da-815f-c3b241d99b38.png',
        prompt: `Product photo of men's gunmetal rectangular eyeglasses on solid white background (#FFFFFF).
          Slim rectangular frame, dark gunmetal finish.
          Front view, floating centered, slight shadow below.
          Clean studio lighting, professional business style.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/9b4b8d54-18ce-46da-815f-c3b241d99b38.png',
      },
      {
        id: 'glasses-6',
        name: 'Brown Square',
        category: 'glasses',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/a5fbc14c-35d0-47ef-abe8-b99ce45fa585.png',
        prompt: `Product photo of men's brown square eyeglasses on solid white background (#FFFFFF).
          Modern square shape, warm brown acetate frame.
          Front view, floating centered, slight shadow below.
          Clean studio lighting, smart casual style.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/a5fbc14c-35d0-47ef-abe8-b99ce45fa585.png',
      },
      {
        id: 'glasses-7',
        name: 'Silver Sport',
        category: 'glasses',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/08e10371-4472-4d0d-90a2-d3376da0f8c4.png',
        prompt: `Product photo of men's silver wraparound sport sunglasses on solid white background (#FFFFFF).
          Athletic wraparound design, silver frame, mirrored lenses.
          Front view, floating centered, slight shadow below.
          Clean studio lighting, active sporty style.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/08e10371-4472-4d0d-90a2-d3376da0f8c4.png',
      },
      {
        id: 'glasses-8',
        name: 'Clear Frame',
        category: 'glasses',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/71033905-f0b1-4a3d-9023-1939fde8994d.png',
        prompt: `Product photo of men's clear frame eyeglasses on solid white background (#FFFFFF).
          Modern square shape, clear transparent acetate.
          Front view, floating centered, slight shadow below.
          Clean studio lighting, trendy minimalist style.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/71033905-f0b1-4a3d-9023-1939fde8994d.png',
      },
      {
        id: 'glasses-9',
        name: 'Black Shield',
        category: 'glasses',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/c35f4aef-ecda-475e-b16e-8c23da7f3182.png',
        prompt: `Product photo of men's black shield sunglasses on solid white background (#FFFFFF).
          Large single lens shield design, black frame.
          Front view, floating centered, slight shadow below.
          Clean studio lighting, bold modern style.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/c35f4aef-ecda-475e-b16e-8c23da7f3182.png',
      },
    ],
  },
  {
    id: 'bags',
    label: 'Bags',
    icon: IconToteBag,
    items: [
      {
        id: 'bag-1',
        name: 'Black Backpack',
        category: 'bags',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/873092f3-288e-4c56-8ae4-228f8836b4b8.png',
        prompt: `Product photo of men's black nylon backpack on solid white background (#FFFFFF).
          Modern design, padded straps, multiple compartments.
          3/4 angle view, standing upright.
          Clean studio lighting, urban professional style.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/873092f3-288e-4c56-8ae4-228f8836b4b8.png',
      },
      {
        id: 'bag-2',
        name: 'Brown Briefcase',
        category: 'bags',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/93857c8c-5d49-4b60-b737-b9e34cc3381c.png',
        prompt: `Product photo of men's brown leather briefcase on solid white background (#FFFFFF).
          Classic design, dual handles, brass hardware.
          3/4 angle view, standing upright.
          Clean studio lighting, executive sophistication.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/93857c8c-5d49-4b60-b737-b9e34cc3381c.png',
      },
      {
        id: 'bag-3',
        name: 'Navy Messenger',
        category: 'bags',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/d911e4ad-a3df-4a8c-b51c-4496b2b24f4f.png',
        prompt: `Product photo of men's navy canvas messenger bag on solid white background (#FFFFFF).
          Crossbody design, leather trim, adjustable strap.
          3/4 angle view, strap draped.
          Clean studio lighting, casual professional style.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/d911e4ad-a3df-4a8c-b51c-4496b2b24f4f.png',
      },
      {
        id: 'bag-4',
        name: 'Gray Duffle',
        category: 'bags',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/b77e5855-06ff-4ac9-a312-ec96394829a7.png',
        prompt: `Product photo of men's gray canvas duffle bag on solid white background (#FFFFFF).
          Large duffle design, leather handles, shoulder strap.
          3/4 angle view, laying slightly tilted.
          Clean studio lighting, travel ready style.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/b77e5855-06ff-4ac9-a312-ec96394829a7.png',
      },
      {
        id: 'bag-5',
        name: 'Tan Leather Tote',
        category: 'bags',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/c2ee5bdf-e6b2-41fd-9b44-d4c856bbbcb7.png',
        prompt: `Product photo of men's tan leather tote bag on solid white background (#FFFFFF).
          Simple tote design, sturdy handles, minimalist.
          3/4 angle view, standing upright.
          Clean studio lighting, sophisticated casual style.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/c2ee5bdf-e6b2-41fd-9b44-d4c856bbbcb7.png',
      },
      {
        id: 'bag-6',
        name: 'Black Sling Bag',
        category: 'bags',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/0c310562-75e1-4340-b525-881cf7b6986f.png',
        prompt: `Product photo of men's black crossbody sling bag on solid white background (#FFFFFF).
          Compact sling design, single strap, multiple pockets.
          3/4 angle view, urban minimalist style.
          Clean studio lighting, modern practical.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/0c310562-75e1-4340-b525-881cf7b6986f.png',
      },
      {
        id: 'bag-7',
        name: 'Olive Weekender',
        category: 'bags',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/08dcfec5-5ad0-4286-82fb-f0391a6ac375.png',
        prompt: `Product photo of men's olive canvas weekender bag on solid white background (#FFFFFF).
          Large overnight bag, leather straps, brass zippers.
          3/4 angle view, laying naturally.
          Clean studio lighting, adventure ready style.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/08dcfec5-5ad0-4286-82fb-f0391a6ac375.png',
      },
      {
        id: 'bag-8',
        name: 'Black Laptop Bag',
        category: 'bags',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/63abf68f-4e5e-4b94-a890-83c7896281e5.png',
        prompt: `Product photo of men's black leather laptop bag on solid white background (#FFFFFF).
          Slim design, top handle, shoulder strap, padded interior.
          3/4 angle view, standing upright.
          Clean studio lighting, tech professional style.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/63abf68f-4e5e-4b94-a890-83c7896281e5.png',
      },
      {
        id: 'bag-9',
        name: 'Brown Gym Bag',
        category: 'bags',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/1e3b986c-e709-49a1-b490-333df47c25d1.png',
        prompt: `Product photo of men's brown leather gym bag on solid white background (#FFFFFF).
          Boston bag style, dual handles, zip closure.
          3/4 angle view, casual athletic style.
          Clean studio lighting, classic sporty look.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/1e3b986c-e709-49a1-b490-333df47c25d1.png',
      },
    ],
  },
  {
    id: 'hats',
    label: 'Hats',
    icon: IconStrawHat,
    items: [
      {
        id: 'hat-1',
        name: 'Black Baseball Cap',
        category: 'hats',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/f411c9e0-c172-4f55-a7af-6177b7ce417f.png',
        prompt: `Product photo of men's black baseball cap on solid white background (#FFFFFF).
          Classic curved brim, solid black cotton, adjustable back.
          3/4 angle view, casual sporty style.
          Clean studio lighting, everyday essential.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/f411c9e0-c172-4f55-a7af-6177b7ce417f.png',
      },
      {
        id: 'hat-2',
        name: 'Navy Snapback',
        category: 'hats',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/ca8eeaf4-77b8-4029-bb0c-f85fb0ace988.jpg',
        prompt: `Product photo of men's navy blue snapback cap on solid white background (#FFFFFF).
          Flat brim, structured crown, snap closure.
          3/4 angle view, street style aesthetic.
          Clean studio lighting, urban cool.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/ca8eeaf4-77b8-4029-bb0c-f85fb0ace988.jpg',
      },
      {
        id: 'hat-3',
        name: 'Gray Beanie',
        category: 'hats',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/7e4ec063-9630-4226-a1d8-6684a371ef53.png',
        prompt: `Product photo of men's gray knit beanie on solid white background (#FFFFFF).
          Ribbed knit, cuffed style, charcoal gray.
          3/4 angle view, casual winter style.
          Clean studio lighting, cozy essential.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/7e4ec063-9630-4226-a1d8-6684a371ef53.png',
      },
      {
        id: 'hat-4',
        name: 'Brown Fedora',
        category: 'hats',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/54d80658-3c49-4b05-a4b8-9eb618e36762.png',
        prompt: `Product photo of men's brown felt fedora on solid white background (#FFFFFF).
          Classic fedora shape, medium brim, black band.
          3/4 angle view, sophisticated style.
          Clean studio lighting, timeless elegance.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/54d80658-3c49-4b05-a4b8-9eb618e36762.png',
      },
      {
        id: 'hat-5',
        name: 'Khaki Bucket Hat',
        category: 'hats',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/3c65536d-c577-469b-8348-5cb0b73fda59.png',
        prompt: `Product photo of men's khaki bucket hat on solid white background (#FFFFFF).
          Soft bucket shape, downward brim, cotton material.
          3/4 angle view, casual outdoor style.
          Clean studio lighting, relaxed summer vibe.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/3c65536d-c577-469b-8348-5cb0b73fda59.png',
      },
      {
        id: 'hat-6',
        name: 'Black Flat Cap',
        category: 'hats',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/ef0da0aa-1ee6-4864-92cd-277f0724668e.png',
        prompt: `Product photo of men's black flat cap on solid white background (#FFFFFF).
          Classic newsboy flat cap, wool blend, snap brim.
          3/4 angle view, vintage gentleman style.
          Clean studio lighting, classic sophistication.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/ef0da0aa-1ee6-4864-92cd-277f0724668e.png',
      },
      {
        id: 'hat-7',
        name: 'White Trucker Hat',
        category: 'hats',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/942a6be8-abdf-4b5f-b8e1-37c6477d4544.png',
        prompt: `Product photo of men's white and navy trucker hat on solid white background (#FFFFFF).
          Mesh back, foam front, curved brim, snap closure.
          3/4 angle view, casual summer style.
          Clean studio lighting, retro Americana.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/942a6be8-abdf-4b5f-b8e1-37c6477d4544.png',
      },
      {
        id: 'hat-8',
        name: 'Olive Beanie',
        category: 'hats',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/cf85c453-7603-4b97-9280-62fbb850f2ae.png',
        prompt: `Product photo of men's olive green knit beanie on solid white background (#FFFFFF).
          Slouchy fit, ribbed knit, military olive color.
          3/4 angle view, casual streetwear style.
          Clean studio lighting, urban outdoors.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/cf85c453-7603-4b97-9280-62fbb850f2ae.png',
      },
      {
        id: 'hat-9',
        name: 'Tan Panama Hat',
        category: 'hats',
        thumbnailUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/548e4bd3-181f-457f-8ca5-bfd061f0b50e.png',
        prompt: `Product photo of men's tan straw panama hat on solid white background (#FFFFFF).
          Classic panama shape, woven straw, black ribbon band.
          3/4 angle view, summer elegance.
          Clean studio lighting, resort ready style.`,
        imageUrl: 'https://cdn-cms-uploads.picsart.com/cms-uploads/548e4bd3-181f-457f-8ca5-bfd061f0b50e.png',
      },
    ],
  },
];

// Get wardrobe categories by gender
export function getWardrobeCategoriesByGender(gender: Gender): WardrobeCategoryData[] {
  switch (gender) {
    case 'female':
      return FEMALE_WARDROBE_CATEGORIES;
    case 'male':
      return MALE_WARDROBE_CATEGORIES;
    default:
      return FEMALE_WARDROBE_CATEGORIES; // Default to female
  }
}

// Legacy export (defaults to female)
export const GENERATED_WARDROBE_CATEGORIES = FEMALE_WARDROBE_CATEGORIES;
